export const HexToRGB = (hex) => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const HEX = hex.replace(shorthandRegex, (m, r, g, b) => { return r + r + g + g + b + b; });
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(HEX);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
  } : null;
};

export const getColorTransparencyFromPercent = (percentage, transparency) => {
  const scaled = percentage / 100.0;
  const hue = ((scaled) * 127).toString(10);
  return ['hsla(', hue, ',50%,50%,', transparency, ')'].join('');
};

export const getColorBasedOnPercentage = (percentage) => {
  const scaled = percentage / 100.0;
  const hue = ((scaled) * 127).toString(10);
  return ['hsl(', hue, ',50%,50%)'].join('');
};

export const rgbToHex = (r, g, b) => `#${[r, g, b].map((x) => {
  const hex = x.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}).join('')}`;
